import React from "react";
import Button from "./sub-components/Button";
import { motion } from "framer-motion";

function Contact() {
  return (
    <motion.div
      className="h-screen mt-[200]  flex flex-col"
      id="contact"
      initial={{ x: "-100vw", opacity: 0.1 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ type: "spring", delay: 0.5, stiffness: 120 }}
    >
      <div className="flex items-center gap-4 justify-center">
        <div className="w-[10%] h-0.5 bg-[#ccd6f6] rounded-full"></div>
        <h3 className="text-center md:text-left font-bold text-2xl md:text-4xl mb-[10px] md:mb-[30px]">
          Get in touch
        </h3>
        <div className="w-[10%] h-0.5 bg-[#ccd6f6] rounded-full"></div>
      </div>
      <p className=" text-center text-xs md:text-base mx-auto w-[70%]">
        I am currently looking for junior frontend developer roles or internship
        where I can put my learning to practice and also get experience in
        solving real world problems.
      </p>
      <div className="mx-auto mt-[30px]">
        {" "}
        <Button />
      </div>
    </motion.div>
  );
}

export default Contact;
